import api from '../../api';
import { mediaTreeSchema, mediaFolderSchema } from '../schemas';

/**
 * Get user media tree.
 * @param {object} params
 * @param {string} [params.path=''] - "root" or the ID of the folder to fetch.
 * @returns {Promise<MediaTree>}
 */
export const getMyMediaTree = async (params) => {
  const result = await api.get(
    '/content-management/v1-0/admin/media-trees/mine',
    { params },
  );

  try {
    await mediaTreeSchema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match My Media Tree Schema : ${error.message}`);
  }

  return result.data;
};
/**
 * Get a media folder by its ID.
 * @param {string} mediaFolderId
 * @returns {Promise<MediaFolder>}
 */
export const getMediaFolder = async (mediaFolderId) => {
  const result = await api.get(`/content-management/v1-0/admin/media-trees/mine/media-folders/${mediaFolderId}`);

  try {
    await mediaFolderSchema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match Media Folder Schema : ${error.message}`);
  }

  return result.data;
};
/**
 * Update a Media Folder
 * @param {string} mediaFolderId
 * @param {object} updatedMediaFolder
 * @param {string} updatedMediaFolder.name
 * @param {number} version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const updateMediaFolder = async (mediaFolderId, updatedMediaFolder, version) => api.patch(
  `/content-management/v1-0/admin/media-trees/mine/media-folders/${mediaFolderId}`,
  updatedMediaFolder,
  {
    headers: {
      'X-Presumed-Version': version,
    },
  },
);
/**
 * Create a new Media Folder
 * @param {object} newMediaFolder
 * @param {string} newMediaFolder.name
 * @param {string} newMediaFolder.folderId
 * @param {number} newMediaFolder.version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postMediaFolder = async (newMediaFolder) => api.post(
  '/content-management/v1-0/admin/media-trees/mine/media-folders',
  newMediaFolder,
  {
    headers: {
      'X-Presumed-Version': newMediaFolder.version,
    },
  },
);
/**
 * Moove to Media Folder
 * @param {object} mediaFolderMove
 * @param {Array<string>} mediaFolderMove.movedMediaIds
 * @param {Array<string>} mediaFolderMove.movedMediaFolderIds
 * @param {string} mediaFolderMove.destinationMediaFolderId
 * @param {number} mediaFolderMove.version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postMoveMediaFolder = async (mediaFolderMove) => api.post('/content-management/v1-0/admin/media-trees/mine:move-to-media-folder', mediaFolderMove, {
  headers: {
    'X-Presumed-Version': mediaFolderMove.version,
  },
});
/**
 Delete a Media Folder
 * @param {string} mediaFolderId
 * @param {number} version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const deleteMediaFolder = async (mediaFolderId, version) => api.delete(`/content-management/v1-0/admin/media-trees/mine/media-folders/${mediaFolderId}`, {
  headers: {
    'X-Presumed-Version': version,
  },
});
